export var onDarkColor = "#fff";
export var onBrightColor = "#000";
export var onDarkColorValues = {
  color: onDarkColor,
  emphasis: {
    high: {
      "default": 1,
      hover: 0.8
    },
    medium: {
      "default": 0.8,
      hover: 1
    },
    half: {
      "default": 0.5,
      hover: 1
    },
    low: {
      "default": 0.4,
      hover: 0.8
    },
    extraLow: {
      "default": 0.2,
      hover: 0.8
    }
  }
};
export var onBrightColorValues = {
  color: onBrightColor,
  emphasis: {
    high: {
      "default": 1,
      hover: 0.7
    },
    medium: {
      "default": 0.7,
      hover: 1
    },
    half: {
      "default": 0.5,
      hover: 1
    },
    low: {
      "default": 0.3,
      hover: 0.7
    },
    extraLow: {
      "default": 0.1,
      hover: 0.7
    }
  }
};